import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { AlertService } from 'src/app/services/alert.service';
import { CashBookingService } from 'src/app/services/cashbooking.service';
import { InputformatService } from 'src/app/services/inputformat.service';
import { AttachmentType } from 'src/enum/attachmentType.enum';
import { FileType } from 'src/enum/fileType.enum';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-paccsserviceprovideredit',
  templateUrl: './paccsserviceprovideredit.component.html',
  styleUrls: ['./paccsserviceprovideredit.component.scss']
})
export class PaccsserviceprovidereditComponent implements OnInit {

  form!: FormGroup;
  districtList: any = [];
  talukList: any = [];
  blockList: any = [];
  villageList: any = [];
  genderList: any = [];
  attachmentData: any[] = [];
  passBookattachmentData: any[] = [];
  paccsTypeList: any = [];
  formDataPatchValue: any
  isAccountVerified: any;
  fileName: any;
  passbookfileName: any;
  dateWithTime: string;
  dateWithTime1: string;
  FileExtention: any;
  FileExtention1: any
  BannerImage: File;
  BannerImage1: File;
  userImageBase64: string;
  attachmentType = AttachmentType;
  fileTypeEnum = FileType;
  bannerImageSrc: string | null = null;
  bannerImageSrc1: string | null = null;
  public imageBaseUrl = environment.imageBaseUrl;

  constructor(private inputFormatService: InputformatService,
    private formBuilder: FormBuilder,
    private cashBookingService: CashBookingService,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dialogRef: MatDialogRef<PaccsserviceprovidereditComponent>,
    private alertService: AlertService,
    private cdr: ChangeDetectorRef
  ) {
    this.formDataPatchValue = this.dialogData.data
    this.isAccountVerified = this.dialogData.data.isAccountVerified
  }

  ngOnInit() {
    this.initialValidators();
    this.genderLookup();
    this.getDistrict();
    this.getPaccsType();
    this.form.patchValue(this.formDataPatchValue)
    this.loadDataFromPayloadPan(this.dialogData.data.attachment)
    this.loadDataFromPayloadPassBook(this.dialogData.data.bankPassBookImagePath)
    if (this.isAccountVerified == true) {
      this.disabledBankDetails();
    }
  }

  disabledBankDetails() {
    this.form.get('bankName').disable();
    this.form.get('accountNumber').disable();
    this.form.get('branchName').disable();
    this.form.get('ifscCode').disable();
    this.form.get('cityName').disable();
  }

  initialValidators() {
    this.form = this.formBuilder.group({
      id: [0],
      name: [null, [Validators.required, Validators.pattern(/^[A-Za-z\u0B80-\u0BFF ]+$/)]],
      paccsType: [null, Validators.required],
      ePaccsRefNo: ['', [
        Validators.required,
        Validators.pattern('^[0-9]{14}$'),
        Validators.minLength(14),
        Validators.maxLength(14)
      ]],
      genderType: [null, [Validators.required]],
      mobileNo: [null, [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]],
      panNo: ['', [Validators.required, Validators.pattern('^[A-Za-z]{5}[0-9]{4}[A-Za-z]{1}$')]],
      attachment: [null, Validators.required],
      accountPassBookattachment: [null, Validators.required],
      address: ['', [Validators.required]],
      districtId: [null, [Validators.required]],
      talukId: [null, [Validators.required]],
      blockId: [null, [Validators.required]],
      gramPanchayatId: [null, [Validators.required]],
      pinCode: ['', [Validators.required, Validators.pattern('^[6]{1}[0-9]{5}$')]],
      secretaryName: ['', [Validators.required, Validators.pattern(/^[A-Za-z\u0B80-\u0BFF ]+$/)]],
      bankName: ['', [Validators.required, Validators.pattern(/^[A-Za-z\u0B80-\u0BFF ]+$/)]],
      accountNumber: ['', [Validators.required, Validators.pattern(/^[0-9]+$/)]],
      branchName: ['', [Validators.required, Validators.pattern(/^[A-Za-z\u0B80-\u0BFF ]+$/)]],
      ifscCode: [[0], [Validators.required, Validators.pattern('^[A-Za-z]{4}0[A-Z0-9a-z]{6}$')]],
      cityName: ['', [Validators.required, Validators.pattern(/^[A-Za-z\u0B80-\u0BFF ]+$/)]],
    });
  }

  back() {

  }

  onInput(event: any, regexPattern: any): void {
    this.inputFormatService.isNumericOrHyphenOrSpace(event, regexPattern);
  }

  genderLookup() {
    this.cashBookingService.getGenderType(true).subscribe((res) => {
      this.genderList = res;
    });
  }
  getPaccsType() {
    this.cashBookingService.getCooperativeInstitution().subscribe((res) => {
      this.paccsTypeList = res;
    });
  }

  getDistrict() {
    this.cashBookingService.districtLookup().subscribe((res) => {
      this.districtList = res;
      let district = this.districtList;
      this.districtList = district;
      this.getTaluk();
    });
  }
  districtChange() {
    this.talukList = [];
    this.blockList = [];
    this.villageList = [];
    this.form.controls['talukId'].setValue(null);
    this.form.controls['blockId'].setValue(null);
    this.form.controls['gramPanchayatId'].setValue(null);
    this.getTaluk();
  }

  talukChange() {
    this.blockList = [];
    this.villageList = [];
    this.form.controls['blockId'].setValue(null);
    this.form.controls['gramPanchayatId'].setValue(null);
    this.getBlock();
  }
  getTaluk() {
    this.cashBookingService
      .talukLookup(this.form.value.districtId)
      .subscribe((res) => {
        this.talukList = res;
        this.getBlock()
      });
  }

  blockChange() {
    this.villageList = [];
    this.form.controls['gramPanchayatId'].setValue(null);
    this.getgramPanchayat();
  }

  getBlock() {
    this.cashBookingService
      .blockLookup(this.form.value.districtId)
      .subscribe((res) => {
        this.blockList = res;
        this.getgramPanchayat();
      });
  }

  getgramPanchayat() {
    this.cashBookingService
      .getgramPanchayatData(this.form.value.blockId, 1, true)
      .subscribe((result) => {
        this.villageList = result;
      });
  }

  closeDialog(): void {
    const closeDlg = { isClosed: true }
    this.dialogRef.close(closeDlg);
  }

  allowOnlyPositiveIntegers(event: KeyboardEvent): void {
    const inputChar = event.key;

    // Block non-digits only
    if (!/^\d$/.test(inputChar)) {
      event.preventDefault();
      return;
    }
  }

  submit() {
    const updatedAttachmentData = this.attachmentData.map((v) => {
      return {
        ...v,
        base64String: v.base64String.replace(
          /^data:image\/(png|jpeg|jpg|PNG|JPEG|JPG);base64,/,
          ''
        ),
      };
    });

    const passBookUpdatedAttachmentData = this.passBookattachmentData.map((v) => {
      return {
        ...v,
        base64String: v.base64String.replace(
          /^data:image\/(png|jpeg|jpg|PNG|JPEG|JPG);base64,/,
          ''
        ),
      };
    });

    if (this.form.get('paccsType')?.value != 1) {
      this.form.controls['ePaccsRefNo'].setValue("");
      this.form.controls['ePaccsRefNo'].clearValidators();
      this.form.controls['ePaccsRefNo'].updateValueAndValidity();
    }

    if (this.form.valid) {
      const payload = {
        ServiceProviderId: this.form.value.id,
        Name: this.form.value.name,
        PaccsType: this.form.value.paccsType,
        EPaccsRefNo: this.form.value.ePaccsRefNo,
        SecretaryName: this.form.value.secretaryName,
        GenderType: this.form.value.genderType,
        MobileNo: this.form.value.mobileNo,
        PanNo: this.form.value.panNo,
        Attachment: updatedAttachmentData,
        PassBookAttachment: passBookUpdatedAttachmentData,
        Address: this.form.value.address,
        DistrictId: this.form.value.districtId,
        TalukId: this.form.value.talukId,
        BlockId: this.form.value.blockId,
        GramPanchayatId: this.form.value.gramPanchayatId,
        PinCode: this.form.value.pinCode,
        BankName: this.form.value.bankName,
        AcNo: this.form.value.accountNumber,
        BranchName: this.form.value.branchName,
        IFSC: this.form.value.ifscCode,
        CityName: this.form.value.cityName,
      }
      this.cashBookingService.serviceProviderUpdate(payload).subscribe((result) => {
        if (result) {
          this.dialogRef.close(result)
        } else {
          this.alertService.error('error')
        }
      })
    } else {
      this.form.markAllAsTouched()
      this.alertService.error('Please fill in the mandatory fields')
    }
  }

  selectFile(): void {
    if (!this.fileName) {
      this.form.controls['attachment'].markAsTouched();
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();
      inputElement.addEventListener('change', (event) => {
        const files: FileList | null = (event.target as HTMLInputElement).files;

        if (!files || files.length == 0) {
          Swal.fire('Warning', 'Please upload file', 'warning');
          return;
        }
        this.dateWithTime = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.fileName = files[0]?.name;
        var file: any = files[0];
        var fileExtension = this.fileName.slice(
          this.fileName.lastIndexOf('.') + 1
        );
        var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
        var result =
          '|png|jpeg|jpg|pdf'.indexOf(type) !== -1 ||
          '|png|jpeg|jpg|pdf'.indexOf(fileExtension) !== -1;

        if (this.fileName && this.fileName.length >= 100) {
          Swal.fire('The selected file name is too large');
          return;
        }

        const existingIndex = this.attachmentData.findIndex(
          (v) => v.attachmentType === this.attachmentType.Pan
        );
        if (existingIndex !== -1) {
          this.attachmentData.splice(existingIndex, 1);
        }

        if (!result) {
          Swal.fire(
            'Warning',
            `Please upload a Correct File Format (PNG, JPEG, JPG, PDF)`,
            'warning'
          );
          this.fileName = '';
          this.dateWithTime = '';
          this.form.controls['attachment'].setValue('');
          return;
        }
        if (file.size > 2097152) {
          Swal.fire(
            'Warning',
            `The file being uploaded can't be more than 2MB`,
            'warning'
          );
          this.fileName = '';
          this.dateWithTime = '';
          this.form.controls['attachment'].setValue('');
          return;
        }
        this.FileExtention = fileExtension;
        this.BannerImage = file;
        const reader = new FileReader();
        reader.onloadend = () => {
          this.userImageBase64 = reader.result as string;
          this.userImageBase64 = `data:image/${fileExtension === 'jpg' || type === 'jpeg' ? 'jpeg' : 'png'
            };base64,${this.userImageBase64.split(',')[1]}`;

          let bannerImageElement = document.getElementById(
            'bannerImage'
          ) as HTMLImageElement;
          let fileType;
          if (type == '|pdf|') {
            fileType = this.fileTypeEnum.Pdf;
          } else {
            fileType = this.fileTypeEnum.Image;
            bannerImageElement.src = this.userImageBase64;
          }
          this.attachmentData.push({
            id: 0,
            base64String: this.userImageBase64,
            attachmentFilename: this.fileName,
            fileType: fileType,
            attachmentType: this.attachmentType.Pan,
          });
        };
        reader.readAsDataURL(file);
        reader.onerror = function () {
          Swal.fire('Error', 'Failed to read file', 'error');
        };
        document.body.removeChild(inputElement);
        this.form.controls['attachment'].setValue(this.fileName);
      });
    }
  }

  passBookSelectFile(): void {
    if (!this.passbookfileName) {
      this.form.controls['accountPassBookattachment'].markAsTouched();
      const inputElement = document.createElement('input');
      inputElement.type = 'file';
      inputElement.style.display = 'none';
      document.body.appendChild(inputElement);
      inputElement.click();
      inputElement.addEventListener('change', (event) => {
        const files: FileList | null = (event.target as HTMLInputElement).files;

        if (!files || files.length == 0) {
          Swal.fire('Warning', 'Please upload file', 'warning');
          return;
        }
        this.dateWithTime1 = moment(new Date()).format('YYYY-MM-DD HH:mm:ss');
        this.passbookfileName = files[0]?.name;
        var file: any = files[0];
        var fileExtension = this.passbookfileName.slice(
          this.passbookfileName.lastIndexOf('.') + 1
        );
        var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
        var result =
          '|png|jpeg|jpg|pdf'.indexOf(type) !== -1 ||
          '|png|jpeg|jpg|pdf'.indexOf(fileExtension) !== -1;

        if (this.passbookfileName && this.passbookfileName.length >= 100) {
          Swal.fire('The selected file name is too large');
          return;
        }

        const existingIndex = this.passBookattachmentData.findIndex(
          (v) => v.attachmentType === this.attachmentType.BankPassBook
        );
        if (existingIndex !== -1) {
          this.passBookattachmentData.splice(existingIndex, 1);
        }

        if (!result) {
          Swal.fire(
            'Warning',
            `Please upload a Correct File Format (PNG, JPEG, JPG, PDF)`,
            'warning'
          );
          this.passbookfileName = '';
          this.dateWithTime1 = '';
          this.form.controls['accountPassBookattachment'].setValue('');
          return;
        }
        if (file.size > 2097152) {
          Swal.fire(
            'Warning',
            `The file being uploaded can't be more than 2MB`,
            'warning'
          );
          this.passbookfileName = '';
          this.dateWithTime1 = '';
          this.form.controls['accountPassBookattachment'].setValue('');
          return;
        }
        this.FileExtention1 = fileExtension;
        this.BannerImage1 = file;
        const reader = new FileReader();
        reader.onloadend = () => {
          this.userImageBase64 = reader.result as string;
          this.userImageBase64 = `data:image/${fileExtension === 'jpg' || type === 'jpeg' ? 'jpeg' : 'png'
            };base64,${this.userImageBase64.split(',')[1]}`;

          let bannerImageElement = document.getElementById(
            'bannerImage1'
          ) as HTMLImageElement;
          let fileType;
          if (type == '|pdf|') {
            fileType = this.fileTypeEnum.Pdf;
          } else {
            fileType = this.fileTypeEnum.Image;
            bannerImageElement.src = this.userImageBase64;
          }
          this.passBookattachmentData.push({
            id: 0,
            base64String: this.userImageBase64,
            attachmentFilename: this.passbookfileName,
            fileType: fileType,
            attachmentType: this.attachmentType.BankPassBook,
          });
        };
        reader.readAsDataURL(file);
        reader.onerror = function () {
          Swal.fire('Error', 'Failed to read file', 'error');
        };
        document.body.removeChild(inputElement);
        this.form.controls['accountPassBookattachment'].setValue(this.passbookfileName);
      });
    }
  }


  loadDataFromPayloadPan(attachmentPath: any): void {
    this.fileName = attachmentPath
      ? attachmentPath.split('/').pop()
      : '';
    const fileExtension = this.fileName?.split('.').pop()?.toLowerCase();
    this.form.controls['attachment'].setValue(this.fileName);

    this.FileExtention = fileExtension;
    if (attachmentPath) {
      if (this.isImageFile(fileExtension)) {
        this.FileExtention = fileExtension;
        this.bannerImageSrc = `${this.imageBaseUrl}/${attachmentPath}`;
      } else {
        this.bannerImageSrc = null;
      }
    } else {
      this.bannerImageSrc = null;
    }
  }

  loadDataFromPayloadPassBook(attachmentPath: any): void {
    this.passbookfileName = attachmentPath
      ? attachmentPath.split('/').pop()
      : '';
    const fileExtension = this.passbookfileName?.split('.').pop()?.toLowerCase();
    this.form.controls['accountPassBookattachment'].setValue(this.passbookfileName);

    this.FileExtention1 = fileExtension;
    if (attachmentPath) {
      if (this.isImageFile(fileExtension)) {
        this.FileExtention1 = fileExtension;
        this.bannerImageSrc1 = `${this.imageBaseUrl}/${attachmentPath}`;
      } else {
        this.bannerImageSrc1 = null;
      }
    } else {
      this.bannerImageSrc1 = null;
    }
  }

  isImageFile(path: any): boolean {
    const extension = path.split('.').pop()?.toLowerCase();
    return extension ? ['png', 'jpeg', 'jpg'].includes(extension) : false;
  }

  deleteImage(controller: any, id: any) {
    const txt = 'Are you sure you want to delete this?';
    const Yes = 'Yes';
    const No = 'No';
    Swal
      .fire({
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: Yes,
        cancelButtonText: No,
      })
      .then((result) => {
        if (result.value) {
          if (controller === 'attachment') {
            this.fileName = '';
            this.dateWithTime = ' ';
          }
          this.form.controls[controller].setValue('');
          const bannerImageElement: any = document.getElementById(
            id
          ) as HTMLImageElement;
          bannerImageElement.src = null;
        }
      });
  }


  deletepassbookImage(controller: any, id: any) {
    const txt = 'Are you sure you want to delete this?';
    const Yes = 'Yes';
    const No = 'No';
    Swal
      .fire({
        text: txt,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: Yes,
        cancelButtonText: No,
      })
      .then((result) => {
        if (result.value) {
          if (controller === 'accountPassBookattachment') {
            this.passbookfileName = '';
            this.dateWithTime1 = ' ';
          }
          this.form.controls[controller].setValue('');
          const bannerImageElement: any = document.getElementById(
            id
          ) as HTMLImageElement;
          bannerImageElement.src = null;
        }
      });
  }

  removeSpecialCharacters(): void {
    const panNoControl = this.form.get('panNo');
    let currentValue = panNoControl?.value;

    // Remove any character that is not a letter (A-Z) or a digit (0-9)
    currentValue = currentValue.replace(/[^A-Za-z0-9]/g, '');

    // Update the form control value (keeping the changes in sync with the input)
    panNoControl?.setValue(currentValue.toUpperCase(), { emitEvent: false });

    // If length exceeds 10 characters, truncate the string
    if (currentValue.length > 10) {
      panNoControl?.setValue(currentValue.substring(0, 10), {
        emitEvent: false,
      });
    }
  }
}
